import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
  errorHeader: {
    id: 'frontbucket.errorState.errorHeader',
    description: 'Text for the header of the error when data fail to load',
    defaultMessage: 'Something went wrong...',
  },
  errorDescription: {
    id: 'frontbucket.errorState.errorDescription',
    description:
      'Text for the description of the error when data fail to load. <contactSupport>...</contactSupport> wraps a hyperlink to the Atlassian support contact page; the text inside the tag is the visible link label.',
    defaultMessage:
      'While we check things on our end, <contactSupport>contact support</contactSupport> if the problem persists.',
  },
  errorDescriptionWithCode: {
    id: 'frontbucket.errorState.errorDescriptionWithCode',
    description:
      'Text for the description of the error when data fail to load, shown alongside an error code. <contactSupport>...</contactSupport> wraps a hyperlink to the Atlassian support contact page; the text inside the tag is the visible link label.',
    defaultMessage:
      'If the problem persists, <contactSupport>contact support</contactSupport> and include the error code displayed below.',
  },
  errorLink: {
    id: 'frontbucket.errorState.link',
    description:
      'Label for a link shown during an error, which is used to reload the page',
    defaultMessage: 'Try again',
  },
});
